import moment from "moment-timezone";
import * as kApi from "@constants/api";

export const checkSessionLocal = () => {
  const cur_date = moment().utc().format("DD/MM/YYYY");
  fetch(kApi.API_URL_CACHE_VERSION, {
    method: "GET",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
  })
    .then((res) => res.json())
    .then((res) => {
      const cur_version = res.version;
      const clearCache = () => {
        if ("caches" in window) {
          caches.keys().then((names) => {
            names.forEach((name) => caches.delete(name));
          });
        }
        localStorage.setItem("cacheFront", btoa(cur_date));
        localStorage.setItem("cacheFrontVersion", cur_version);
        window.history.forward(1);
        window.location.reload(true);
      };

      const cacheFrontDate = localStorage.getItem("cacheFront");
      const cacheFrontVersion = localStorage.getItem("cacheFrontVersion");

      if (!(cacheFrontDate || cacheFrontVersion)) {
        clearCache();
      } else {
        if (cur_date !== atob(cacheFrontDate) || cacheFrontVersion !== cur_version) {
          clearCache();
        }
      }
    });
};

export const checkCacheLocal = () => {
  let cur_date = localStorage.getItem("last_check_cache");
  if (cur_date) {
    let hoursDiff = moment().diff(moment(cur_date), "hours");
    if (hoursDiff >= 24) {
      checkSessionLocal();
      localStorage.setItem("last_check_cache", moment().format("YYYY-MM-DD HH:m:ss"));
    }
  } else {
    localStorage.setItem("last_check_cache", moment().format("YYYY-MM-DD HH:m:ss"));
  }
};

export const listenFocusBlurSession = () => {
  let blur_date = null;
  window.onblur = () => {
    blur_date = moment();
  };
  window.onfocus = () => {
    if (blur_date) {
      if (moment().diff(blur_date, "hours") > 0) checkSessionLocal();
    }
  };
};